<template lang="pug">
  div.boxCesiumMap
    object(id='dataIframe' data='./static/resources/GIS_V18/index.html')
</template>

<script>

// COM
export default {
  name: 'CesiumMapObject',
  data () {
    return {
      load: false,
      options: []
    }
  },
  computed: {
  },
  methods: {
    getLoad () {
      return this.load
    }
  },
  mounted () {
    const component = this
    // component.initMap()
    // component.$root.$on('viewerdashboard-clicked', () => component.open())
    document.getElementById('dataIframe').addEventListener('load', function () {
      component.load = true
      component.options = component.$store.getters.getBasemap
      let valueMap = component.$store.getters.getSelectBasemap
      let sel = component.options.filter(d => d.url === valueMap)
      let obj = sel[0]
      document.getElementById('dataIframe').contentWindow.loadBasemap(obj)
      // console.log(component.load)
    })
  }
}
</script>

<style scoped lang="scss">

  .boxCesiumMap{
    object {
      top: 0;
      height: calc(100vh - 64px);
      position: absolute;
      width: 100%;
    }
    & > div {
      height: 100%;
      width: 100%;
    }
  }
  .environment-dashboard{
    height: 100%;
  }
  /deep/ button a {
    color: $--color-white;
  }
  .cesium-map {
    height: calc(100% - 72px);
    z-index: 0;
    background-color: antiquewhite;
    position: absolute;
    &__hand {
      cursor: pointer;
    }
    &__closed {
      transition: width 0.6s ease;
      width: calc(100% - 100px);
    }
    &__opened {
      transition: width 0.6s ease;
      width: calc(70% - 72px);
    }
    &__full-width {
      width: calc(100% - 72px);
    }
  }
  /deep/ .cesium-viewer .cesium-viewer-bottom {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/CesiumMapObject.vue